import { get } from 'lodash';
import { Alert, Col, Row } from 'react-bootstrap';
import {
  currentOrganisationType,
  isBroker,
  isBrokerOrganisation,
} from '../../../../../auth/redux/authActions';
import { Field } from 'redux-form';
import { CommOptions } from '../CommOptions';
import getCommunicationOptionsContent from '../../../../../../helpers/getCommunicationOptionsContent';
import React from 'react';
import './CommunicationsBox.scss';

export const CommunicationsBox = ({
  show,
  customer,
  onCommunicationOptionsChange,
  showAlertEmail,
}) => {
  const mobile = get(customer, 'data.attributes.phone2', []);

  const communicationTypes = Object.keys(
    getCommunicationOptionsContent(currentOrganisationType())['communication_types'],
  );

  const validCommunicationTypes = communicationTypes.filter((communicationType) => {
    return !(communicationType === 'sms' && !mobile);
  });

  if (!show || !validCommunicationTypes.length) {
    return null;
  }

  return (
    <>
      <div className="communications-box">
        <Row>
          <Col sm={12}>
            <p className="communications-box--title">
              {isBroker() || isBrokerOrganisation()
                ? 'Policy Confirmation'
                : 'Sending Policy Documents'}{' '}
            </p>
          </Col>
        </Row>
        <div className={'communications-box--container'}>
          <Field
            name={'data.attributes.metadata.communications'}
            component={CommOptions}
            content={getCommunicationOptionsContent(currentOrganisationType())}
            communicationTypes={validCommunicationTypes}
            handleCommunicationOptionsChange={onCommunicationOptionsChange}
            mobile={mobile}
          />
        </div>
      </div>
      {showAlertEmail && (
        <Row>
          <Col sm={12} style={{ marginTop: '5px' }}>
            <div className="not-found-alert fade in">
              <Alert bsStyle="danger">
                {
                  'If client does not have an email address please untick the email box in the blue box above. Note that if an email address is not provided clients will not be able to access documents online.'
                }
              </Alert>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};
